import { action } from 'satcheljs';
export default action('SHOW_IN_IMMERSIVE_READER', function (itemId) {
    return {
        itemId: itemId,
    };
});
//# sourceMappingURL=showInImmersiveReader.js.map